import { Controller } from "@hotwired/stimulus"
import { updateMemory, deleteMemory, clearAllMemories } from "../modules/salary_lab/advisor_memory_api"

export default class extends Controller {
  static values = {
    updateUrl: String,
    deleteUrl: String,
    clearUrl: String
  }

  edit(event) {
    const id = event.currentTarget.dataset.memoryId
    this._toggleEditMode(id, true)
  }

  cancelEdit(event) {
    const id = event.currentTarget.dataset.memoryId
    this._toggleEditMode(id, false)
  }

  async saveEdit(event) {
    const id = event.currentTarget.dataset.memoryId
    const textarea = this.element.querySelector(`[data-salary-lab-advisor-memory-target="textarea-${id}"]`)
    const content = textarea.value.trim()
    if (!content) return

    const url = this.updateUrlValue.replace(":id", id)
    const result = await updateMemory(url, content)

    if (result.success) {
      const display = this.element.querySelector(`[data-salary-lab-advisor-memory-target="display-${id}"]`)
      const textEl = display.querySelector("p")
      if (textEl) textEl.textContent = content
      this._toggleEditMode(id, false)
    }
  }

  async delete(event) {
    const id = event.currentTarget.dataset.memoryId
    if (!confirm("Delete this memory?")) return

    const url = this.deleteUrlValue.replace(":id", id)
    const result = await deleteMemory(url)

    if (result.success) {
      const card = this.element.querySelector(`[data-memory-id="${id}"]`)
      if (card) card.remove()
    }
  }

  async clearAll() {
    if (!confirm("Clear all memories? This cannot be undone.")) return

    const result = await clearAllMemories(this.clearUrlValue)
    if (result.success) {
      window.location.reload()
    }
  }

  _toggleEditMode(id, editing) {
    const display = this.element.querySelector(`[data-salary-lab-advisor-memory-target="display-${id}"]`)
    const edit = this.element.querySelector(`[data-salary-lab-advisor-memory-target="edit-${id}"]`)
    if (!display || !edit) return

    display.classList.toggle("hidden", editing)
    edit.classList.toggle("hidden", !editing)
  }
}
